export default "__VITE_ASSET__BU7FTnp___"